<template>
    <div class="section">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title has-text-centered">Inland Companies List</h1>
                </div>
            </div>
            <inland-price-table></inland-price-table>
        </div>
    </div>
</template>

<script>
    import InlandPriceTable from './InlandCompaniesTable.vue'
    export default {
        components: {
            InlandPriceTable
        }
    }
</script>

<style scoped>
    .title {
        margin-top: 25px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandComapnies/InlandCompanies.vue